// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'
import { AiComponentRelationTypeSchema } from '../inputTypeSchemas/AiComponentRelationTypeSchema'

/////////////////////////////////////////
// AI COMPONENT RELATION SCHEMA
/////////////////////////////////////////

export const AiComponentRelationSchema = z.object({
  type: AiComponentRelationTypeSchema,
  id: z.string(),
  tenantId: z.string().nullable(),
  applicationId: z.string(),
  sourceId: z.string(),
  targetId: z.string(),
  label: z.string().nullable(),
  metadata: JsonValueSchema.nullable(),
  createdAt: z.coerce.date(),
})

export type AiComponentRelation = z.infer<typeof AiComponentRelationSchema>

export default AiComponentRelationSchema;
